package system

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import component.*

class PreBox2dPhysicSystem : IteratingSystem( family{ all(PhysicComponent)}) {

    override fun onTickEntity(entity: Entity) {
        val physicComponent = entity[PhysicComponent]
        physicComponent.prevPos.set(physicComponent.body.position.x, physicComponent.body.position.y)
    }
}
